import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { globalQueryClient } from 'queries/queryClient'

import { DATE_CONSTANTS } from '@/domain/constants/date'
import { MesureResponseModel } from '@/domain/model/measures'
import { QUERIES } from '@/enums/queries'

import { loadMeasuresByFormAndClientId } from './services/loadMeasuresByFormAndClientId'

export const useLoadMeasuresByFormAndClientId = (
  formId: string,
  clientId: string,
  options?: UseQueryOptions<MesureResponseModel, Error>
): UseQueryResult<MesureResponseModel, Error> => {
  return useQuery({
    queryKey: [QUERIES.MEASURES.LOAD_BY_FORM_AND_CLIENT_ID, formId, clientId],
    queryFn: async () => await loadMeasuresByFormAndClientId(formId, clientId),
    enabled: Boolean(formId && clientId),
    staleTime: DATE_CONSTANTS.TIME_IN_MILLISECONDS.MINUTE * 2,
    ...options,
  })
}

export const invalidateLoadMeasuresByFormAndClientId = async (
  formId: string,
  clientId: string
) => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.MEASURES.LOAD_BY_FORM_AND_CLIENT_ID, formId, clientId],
    exact: false,
  })
}
